import React, { useCallback } from "react";
import { FormControl, Grid, Select, Stack } from "@mui/material";
import CustomMenuItem from "../../../../../../components/Menu/CustomMenuItem";
import criticalIcon from "../../../../../../styles/svg/critical_priority.svg";
import highIcon from "../../../../../../styles/svg/high_priority.svg";

import lowIcon from "../../../../../../styles/svg/low_priority.svg";
import mediumIcon from "../../../../../../styles/svg/medium_priority.svg";  
const CardPriority = ({ priority, updateCardmutate, cardId, boardPermission }) => {
  const handlePriority = useCallback( (value) => {
    updateCardmutate({
      card_id: cardId,
      data: {
        priority: value.target.value,
      },
    });
  },[updateCardmutate, cardId]);
  return (
    <div className="box">
      <Grid item className="allocated-hours">
        <p>Priority</p>
        <FormControl className="taskdetail-sidebar-right-col">
          <Select
            value={priority || ""}
            onChange={handlePriority}
            disabled={!boardPermission?.can_edit_task}
            sx={{
              height: "32px",
              "& .MuiInputBase-input": {
                padding: "7px",
              },
            }}
          >
            {["Critical", "High", "Medium", "Low"].map((value, idx) => (
              <CustomMenuItem key={value} value={value} sx={{ padding: "7px" }}>
                <Stack direction="row" alignItems="center">
                  <img
                    src={
                      idx === 0
                        ? criticalIcon
                        : idx === 1
                        ? highIcon
                        : idx === 2
                        ? mediumIcon
                        : lowIcon
                    }
                    alt="icon"
                    className="priority_icon"
                    style={{
                      marginTop: "3px",
                      marginRight: "4px",
                    }}
                  />
                  <span style={{ fontSize: "14px" }}>{value}</span>
                </Stack>
              </CustomMenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </div>
  );
};

export default React.memo(CardPriority);
